<!-- Add Location Modal -->
<div class="modal fade" id="addLocationModal" tabindex="-1" aria-labelledby="addLocationModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addLocationModalLabel">Add Location</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="addressSearch" class="form-label">Search for an address</label>
          <app-google-places-autocomplete
            placeholder="Enter an address"
            (placeSelected)="onPlaceSelected($event)">
          </app-google-places-autocomplete>
        </div>
        <div class="mb-3" *ngIf="locationStatusText">
          <span class="badge text-bg-{{ locationStatusTheme }}">{{ locationStatusText }}</span>
        </div>
        <div class="mb-3">
          <label for="newLocation" class="form-label">New Location to be added to Fleet: {{getSelectedFleetName()}}:</label>
          <input type="text" class="form-control" id="newLocation" [(ngModel)]="newLocationName" readonly>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" [disabled]="!submitButtonEnabled" (click)="submitNewLocation()">Submit</button>
      </div>
    </div>
  </div>
</div>
